import { DateFormater } from "../text/DateFormater";
import { RegExpUtility } from "../text/RegExpUtility";
import { DateHelper } from "./DateHelper";

export class DateFormatter
{
  //static readonly DeveloperFormat = "yyyy-mm-dd_HH-MM-ss";

  private static _format( value:number, characters:number = 2 )
  {
    let stringValue = value + "";

    while ( stringValue.length < characters )
    {
      stringValue = "0" + stringValue;
    }

    return stringValue;
  }

  static toString( date:Date ):string
  {
    let year = DateFormatter._format( date.getFullYear(), 4 );
    let month =  DateFormatter._format( date.getMonth() + 1 );
    let day =  DateFormatter._format( date.getDate() );
    
    let hours =  DateFormatter._format( date.getHours() );
    let minutes =  DateFormatter._format( date.getMinutes() );
    let seconds =  DateFormatter._format( date.getSeconds() );

    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  }


  static readonly hours = "${hours}";
  static readonly minutes = "${minutes}";
  static readonly seconds = "${seconds}";
  static readonly milliSeconds = "${milliSeconds}";

  static readonly day = "${day}";
  static readonly month = "${month}";
  static readonly year = "${year}";

  static readonly monthName = "${monthName}";
  static readonly MonthName = "${MonthName}";
  static readonly dayCount = "${dayCount}";
  static readonly weekDay = "${weekDay}";


  static customize( date:Date, custom:string ):string
  {
    let year = DateFormatter._format( date.getFullYear(), 4 );
    let month =  DateFormatter._format( date.getMonth() + 1 );
    let monthName = DateFormatter.getMonthInEnglish( date.getMonth() );
    let MonthName = RegExpUtility.upperCaseFirst( DateFormatter.getMonthInEnglish( date.getMonth() ) );
    let weekDay =  DateFormatter._format( date.getDay() );
    let day =  DateFormatter._format( date.getDate() );
    let dayCount = this.dateToWrittenEnglish( date.getDate() );
    
    let hours =  DateFormatter._format( date.getHours() );
    let minutes =  DateFormatter._format( date.getMinutes() );
    let seconds =  DateFormatter._format( date.getSeconds() );
    let milliSeconds =  DateFormatter._format( date.getMilliseconds(), 3 );

    custom = custom.replace( /\$\{year\}/g, year );
    custom = custom.replace( /\$\{month\}/g, month );
    custom = custom.replace( /\$\{monthName\}/g, monthName );
    custom = custom.replace( /\$\{MonthName\}/g, MonthName );
    custom = custom.replace( /\$\{day\}/g, day );
    custom = custom.replace( /\$\{dayCount\}/g, dayCount );
    custom = custom.replace( /\$\{weekDay\}/g, weekDay );

    custom = custom.replace( /\$\{hours\}/g, hours );
    custom = custom.replace( /\$\{minutes\}/g, minutes );
    custom = custom.replace( /\$\{seconds\}/g, seconds );

    custom = custom.replace( /\$\{milliSeconds\}/g, milliSeconds );

    return custom;
  }


  static toDate( stringValue:string )
  {
    let regex = /(\d\d\d\d)\-(\d\d)\-(\d\d)\_(\d\d)\-(\d\d)\-(\d\d)/;
    let result = regex.exec( stringValue );

    let year    = parseFloat( result[ 1 ] );
    let month   = parseFloat( result[ 2 ] ) + 1;
    let day     = parseFloat( result[ 3 ] );
    
    let hours   = parseFloat( result[ 4 ] );
    let minutes = parseFloat( result[ 5 ] );
    let seconds = parseFloat( result[ 6 ] );

    let date = new Date( year, month, day, hours, minutes, seconds);

    return date;
  }

  static toShortInternational( date:Date ):string
  {    
    let day   = DateFormatter._format( date.getDate() );
    let month = DateFormatter._format( date.getMonth() + 1 );
    let year  = DateFormatter._format( date.getFullYear(), 4 );
    
    return `${day}-${month}-${year}`;
  }

  static toShortWithTime( date:Date ):string
  {    
    let dateSring = DateFormatter.toShortInternational( date );
    let time = DateFormatter.customize( date, DateFormatter.hours + ":" + DateFormatter.minutes );

    return dateSring + " " + time;
  }

  static toShortWithTimeForFiles( date:Date ):string
  {    
    let dateSring = DateFormatter.toShortInternational( date );
    let time = DateFormatter.customize( date, DateFormatter.hours + "-" + DateFormatter.minutes );

    return dateSring + "_" + time;
  }

  static readonly months = 
  [ 
    "january", "february", "march", "april",
    "may", "june", "july", "august",
    "september", "october","november","december"
  ]

  static getMonthInEnglish( index:number )
  {
    return DateFormatter.months[ index ];
  }

  


  static readonly UK_Format = `${DateFormatter.dayCount} ${DateFormatter.MonthName} ${DateFormatter.year}`;
  static getUKDateLabel( date:Date )
  {
    return this.customize( date, this.UK_Format );
  }

  static readonly days = 
  [ 
    "sunday", "monday", "tuesday", "wednesday","thursday", "friday", "saturday", "sunday"
  ]

  static readonly days3 = 
  [ 
    "sun", "mon", "tue", "wed","thu", "fri", "sat", "sun"
  ]

  static getWeekDayInEnglish( index:number )
  {
    if ( isNaN( index ) || index < 0 || index > 7 )
    {
      index = 0;
    }

    return DateFormatter.days[ index ];
  }

  static getWeekDayInEnglish3( index:number )
  {
    if ( isNaN( index ) || index < 0 || index > 7 )
    {
      index = 0;
    }

    return DateFormatter.days3[ index ];
  }

  static dateToWrittenEnglish( date:number )
  {
    if ( date % 10 === 1 && date !== 11 )
    {
      return date + "st";
    }

    if ( date % 10 === 2 && date !== 12 )
    {
      return date + "nd";
    }

    if ( date % 10 === 3 && date !== 13 )
    {
      return date + "rd";
    }

    return date + "th";
  }

}